/**
 * E.164 phone number validation utilities.
 *
 * E.164 format: "+" followed by a non-zero leading digit, then 1–14 more
 * digits (total 2–15 digits after the "+", meaning 3–16 characters including
 * the "+" prefix).
 *
 * Note: @kc3/validation exports `phoneE164Schema` but uses the more-restrictive
 * regex /^\+[1-9]\d{6,14}$/ (min 8 total digits) and is not a declared
 * dependency of @kc3/web. This module owns the spec-correct E.164 regex so
 * that short test/internal numbers are correctly validated and the web app
 * has no added package dependency.
 *
 * Phase 2: replace `formatE164ForDisplay` body with libphonenumber-js for
 * human-friendly output (e.g. "+1 (555) 123-4567").
 */

const E164_REGEX = /^\+[1-9]\d{1,14}$/

export function isValidE164(value: string): boolean {
  return E164_REGEX.test(value)
}

/**
 * Format an E.164 number for display.
 *
 * Phase 1 (no-op): returns the value as-is.
 * Phase 2: integrate libphonenumber-js for human-friendly formatting.
 */
export function formatE164ForDisplay(value: string): string {
  return value
}
